// eslint wants to get rid of this, but typescript needs it for our type guard
export const disabledSuspenseQueryData = 'disabled-suspense-query-data' as const;
export const disabledSuspenseQuery = {
  queryKey: ['disabled-suspense-query'],
  queryFn: async () => Promise.resolve(disabledSuspenseQueryData),
} as const;
